import { useRecipientsInfoData, useRecipientsInfoLoading, useSendersInfoData, useSendersInfoLoading, useTransferActions } from 'app/dataProviders/transfer/hooks'
import { PageTemplateContent } from 'app/common/templates-next/page-template'
import { TransferMain } from 'app/common/components/Finances/FinancesFund'


const Transfer = () => {
  const senders = useSendersInfoData()
  const loadingSenders = useSendersInfoLoading()
  const recipients = useRecipientsInfoData()
  const loadingRecipients = useRecipientsInfoLoading()

  const { refetch } = useTransferActions()

  return (
    <PageTemplateContent>
      <TransferMain
        senders={senders}
        recipients={recipients}
        loading={loadingSenders || loadingRecipients}
        onReset={refetch}
      />
    </PageTemplateContent>
  )
}

export default Transfer
